// ======================================================================
// File: src/modules/ipe/enquiry/pages/EnquiriesListPage.js
// ======================================================================

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import EnquiriesKpiBar from "../components/EnquiriesKpiBar";
import EnquiriesFilterBar from "../components/EnquiriesFilterBar";
import EnquiriesTable from "../components/EnquiriesTable";
import EnquiriesPagination from "../components/EnquiriesPagination";

import ipeEnquiryService from "../../services/ipeEnquiryService";

// ----------------------------------------------------------------------
// ✅ STATUS CONFIG (NEW - ERP STANDARD)
// ----------------------------------------------------------------------
export const STATUS_CONFIG = {
  NEW: { label: "New", bg: "#e7f1ff", color: "#1d72f3" },
  STUDY: { label: "Engineering", bg: "#fff4e5", color: "#f4b400" },
  BOM: { label: "BOM", bg: "#f3e8ff", color: "#7b61ff" },
  MOM: { label: "MOM", bg: "#fff1e6", color: "#ff8c42" },
  COSTING: { label: "Costing", bg: "#e6f7fb", color: "#17a2b8" },
  QUOTATION: { label: "Quotation", bg: "#e6f4ea", color: "#28a745" },
  CLOSED: { label: "Closed", bg: "#fdecea", color: "#e5533d" },
};

export default function EnquiriesListPage() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  const hasFilters = Object.keys(filters || {}).length > 0;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await ipeEnquiryService.listEnquiries({
        page,
        page_size: pageSize,
        ...filters,
      });

      setRows(res.items || []);
      setTotal(res.total || 0);
    } finally {
      setLoading(false);
    }
  }, [page, pageSize, filters]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div>

      {/* PAGE HEADER */}
      <div
        style={{
          background: "linear-gradient(90deg, #5f0cff, #7b2cff)",
          borderRadius: 14,
          padding: "16px 22px",
          color: "#fff",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        {/* LEFT */}
        <div>
          <div style={{ fontSize: 20, fontWeight: 700 }}>
            Engineering Enquiries
          </div>
          <div style={{ fontSize: 13, opacity: 0.9 }}>
            Create, track and manage engineering enquiries
          </div>
        </div>

        {/* RIGHT */}
        <button
          onClick={() => navigate("/ipe/enquiries/create")}
          style={{
            background: "#fff",
            color: "#5f0cff",
            border: "none",
            borderRadius: 8,
            padding: "8px 14px",
            fontWeight: 600,
            cursor: "pointer",
          }}
        >
          + Create Enquiry
        </button>
      </div>

      {/* KPI CARDS */}
      <EnquiriesKpiBar rows={rows} />

      {/* FILTERS */}
      <EnquiriesFilterBar
        filters={filters}
        onApply={(f) => {
          setPage(1);
          setFilters(f);
        }}
      />

      {/* TABLE */}
      <EnquiriesTable
        rows={rows}
        loading={loading}
        hasFilters={hasFilters}
        statusConfig={STATUS_CONFIG}   // ✅ PASS CONFIG
      />

      {/* PAGINATION */}
      <EnquiriesPagination
        page={page}
        pageSize={pageSize}
        total={total}
        onPageChange={setPage}
        onPageSizeChange={(s) => {
          setPage(1);
          setPageSize(s);
        }}
      />

    </div>
  );
}